module.exports = __webpack_public_path__ + "app/principal/modals/modal-email-invitation-3FRTfr2R.html";